import { useEffect } from "react";

/**
 * Radix 레이어(Dialog/Select/DropdownMenu/Popover/Tooltip 등)는 modal 동안 `document.body` 에
 * `pointer-events: none` 을 걸어 바깥 클릭을 차단하고, 닫힐 때 복원한다. 그런데 중첩 Radix 가 얽히거나
 * (예: Dialog 안의 Tooltip) 모달/드로어가 그 안의 Radix 레이어가 열린 채로 언마운트되면, 복원이 실행되지
 * 않고 `body { pointer-events: none }` 가 잔존해 **페이지 전체 클릭이 먹지 않는다** (QA B7).
 *
 * 이 훅은 `open` 이 false 로 전이된 뒤 다음 프레임(=Radix 자체 cleanup 이후)에 잔존 여부를 점검해 복원한다.
 * Radix 가 정상 복원한 경우엔 `pointer-events` 가 이미 빈 값이라 아무 일도 하지 않는다.
 */
export function useRestoreBodyPointerEvents(open: boolean) {
  useEffect(() => {
    if (open) return;
    const id = requestAnimationFrame(() => {
      if (document.body.style.pointerEvents === "none") {
        document.body.style.pointerEvents = "";
      }
    });
    return () => cancelAnimationFrame(id);
  }, [open]);
}
